export const DEFAULT_CHART_COLOR = "#64748B"
export const TEAMMEMBER_EMPTY_CHART_MESSAGE = {
  title: "Sin información",
  message:
    "El integrante del equipo seleccionado no tiene registros, intenta cambiando los filtros.",
}

export const CLIENT_REPORT_EMPTY_CHART_MESSAGE = {
  title: "Sin información",
  message: "No hay información disponible para el sprint seleccionado.",
}

export const CLIENT_CONSUMPTION_REPORT_EMPTY_CHART_MESSAGE = {
  title: "Sin información",
  message: "No hay información disponible para el periodo seleccionado.",
}

export const CLIENT_CHART_ALLOWED_SUBTONES = ["600", "300", "700", "200"]
